import React, { useState } from "react";
import ProdListCard from './ProdListCard';
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import utils from '../../other/utils';

const { compareApps, getItemFromStorage } = utils

function union(setA) {
	let unionArr = []
	setA.forEach(el => {
		if (unionArr.includes(el)) {

		} else {
			unionArr.push(+el)
		}
	})
	return unionArr
}

export default function AllAppsTable(props) {
	let cartApps = getItemFromStorage('cartApp')
	
	const { cart, setAppProdBasket, setCheckAll, checkAll, cardArr } = props;
	const [prodBasket, _prodBasket] = useState(JSON.parse(localStorage.getItem('cartProd')) || [])
  const [appBasket, _appBasket] = useState(cartApps)
	const classes = useStyles();
	const wide = false; // codeerr а что мы тут мутим?

	function setAppProd(prod) {
		if (prodBasket.some((element) => element === prod.ID) === true) {
			_prodBasket(prodBasket.filter(el_ => el_ !== prod.ID))
			localStorage.setItem('cartProd', JSON.stringify(prodBasket.filter(el_ => el_ !== prod.ID)))
			let arr_ = []
			appBasket.forEach(el => {
				if (prod['AppsIDsNeeded'] && prod['AppsIDsRecommended'] && prod['AppsIDsNeeded'].length + prod['AppsIDsRecommended'].length > 0 && prod['AppsIDsNeeded'].concat(`,${prod['AppsIDsRecommended']}`).includes(el)) {

				} else {
					arr_.push(el)
				}
			})
			_appBasket(arr_)
			localStorage.setItem('cartApp', JSON.stringify(union(arr_)))

		} else {
			_prodBasket(prodBasket.concat([prod.ID]))
			localStorage.setItem('cartProd', JSON.stringify(prodBasket.concat([prod.ID])))
			if (prod['AppsIDsNeeded'] === null && prod['AppsIDsRecommended'] === null) {
			}
			else if (prod['AppsIDsNeeded'].length + prod['AppsIDsRecommended'].length > 0) {
				let need__ = prod['AppsIDsNeeded'].length > 0 ? prod['AppsIDsNeeded'].split(',') : []
				let recom__ = prod['AppsIDsRecommended'].length > 0 ? prod['AppsIDsRecommended'].split(',') : []
				_appBasket(appBasket.concat(need__.concat(recom__)))
				localStorage.setItem('cartApp', JSON.stringify(union(appBasket.concat(need__.concat(recom__)))))
			}
			else {
			}

		}
	}

	const RenderArr = () =>
		cardArr.map((item, ind) => (
			<Grid item className={classes.ProdListCardCntr} key={`_grid_key${item.AsvulCode}`} >
				<ProdListCard
					setCheckAll={setCheckAll}
					checkAll={checkAll}
					cart={cart}
					data={item}
					wide={wide}
					setAppProd={setAppProd}
					setAppProdBasket={setAppProdBasket}
					dynamics={props.dynamics}
					userCollection = {props.userCollection}
					saveCollection = {props.saveCollection}
					updateArr = {props.updateArr}
				/>
			</Grid>
		))


	return (
		<React.Fragment>
			<RenderArr />
		</React.Fragment>
	)
}

const useStyles = makeStyles(theme => ({
	ChipArrayWhiteCntr: {
		height: 56
	},

	ProdListCardCntr: {
		width: 336
	}
}));